import SettingsService from '../services/settings-service';
import useFetch, { useCacheActions } from './useFetch';
import usePush from './usePush';
import useShortCode from './useShortCode';

const Actions = {
  EDIT_SIGNATURE: 'editSignature',
  EDIT_STATEMENT: 'editStatement',
  SET_CHASE_TIME: 'setChaseTime',
  REVIEW_TEMPLATES: 'reviewTemplates',
  ADD_SCHEDULE: 'addSchedule',
  START_CHASING: 'startChasing',
};

function useCompleteAction() {
  const shortCode = useShortCode();
  const { data: completed = {} } = useFetch(SettingsService.getActionsCompleted, shortCode, {
    suspense: false,
  });
  const { execute } = usePush(SettingsService.setActionCompleted);
  const { invalidateEndpoint } = useCacheActions();

  async function complete(action) {
    if (completed[action]) return;
    const [err, res] = await execute(shortCode, action);
    if (err || !res) return;
    invalidateEndpoint(SettingsService.getActionsCompleted);
  }

  return complete;
}

export default useCompleteAction;
export { Actions };
